import { forwardRef } from "react";

import { Autocomplete } from "@shared/components/DataEntry";

import { FormField } from "../FormField";
import { FormAutocompleteProps } from "../../types";

export const FormAutocomplete = forwardRef<HTMLInputElement, FormAutocompleteProps>(({ name, ...props }, ref) => (
  <FormField name={name}>
    <Autocomplete ref={ref} name={name} {...props} />
  </FormField>
));

FormAutocomplete.displayName = "Form.Autocomplete";
